<template>
  <div class="listSearch">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-listSearch">
          <div class="head-tab--nav">
            <div class="head-nav h-3">
              <!-- <span>招生CRM</span>
              <span>></span>-->
              <span class="c-normal">{{ $t("Admissioncue.dw") }}</span>
              <div class="pull-right">
                <!-- *************暂时隐藏***************** -->
                <!-- <el-button type="primary">导出</el-button> -->
              </div>
            </div>
          </div>
          <div class="listSearch-container">
            <div class="content">
              <div class="content-nav--head text-1">
                <div class="c-n--head_lf">
                  <el-input
                    clearable
                    :placeholder="$t('Admissioncue.dss')"
                    class="input-cont input-keword"
                    style="width:460px"
                    @change="handleSelectKeyword()"
                    v-model="selectForm.keyword"
                  ></el-input>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    @click="handleSelectKeyword()"
                    >{{ $t("Admissioncue.ap") }}</el-button
                  >
                  <!-- <div class="btn-advancedFiter font-gray">
                    <i class="fiter-advance">
                      <img src="../../assets/images/filter.png" alt>
                    </i>
                    高级筛选
                  </div>-->
                  <!-- <el-button type="primary">转回招生线索</el-button> -->
                </div>
              </div>

              <TableList
                :list="tableData"
                :options="optionscaozuo"
                :columns="columns"
                :operates="operates"
                :issetting="false"
                :tableOperate="tableOperate"
                @toggleEditableColumn="toggleEditableColumn"
              ></TableList>

              <!-- <el-pagination
                style="margin-top: 35px;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30,40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>-->
            </div>
          </div>
          <!-- 编辑列 -->
          <!-- <el-dialog
            :title="$t('Admissioncue.dy')"
            class="setting-column"
            :visible.sync="settingVisible"
            width="450px"
            :before-close="handleClose"
          >
            <el-transfer
              :titles="[$t('Admissioncue.bo'), $t('Admissioncue.bp')]"
              v-model="oprateColumn"
              @change="Changeoprate()"
              :data="data"
            ></el-transfer>
            <div class="oprate">
              <el-button type="primary" size="small" @click="handClickOprate()">{{$t("Admissioncue.ax")}}</el-button>
            </div>
          </el-dialog> -->
          <!-- 取消转正提示 -->
          <!-- <el-dialog
            :title="$t('Admissioncue.au')"
            :visible.sync="cancelRegister"
            width="30%"
            :before-close="handleClose"
          >
            <div class="del-box">
              <div class="delTips tc">{{$t("Admissioncue.dz")}}</div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="delDonversionAction()">{{$t("Admissioncue.ax")}}</el-button>
              <el-button @click="cancelRegister = false">{{$t("Customersmanage.bk")}}</el-button>
            </span>
          </el-dialog> -->
        </div>
      </el-main>
    </PageNav>
  </div>
</template>
<script>
import PageNav from "../../components/Nav/nav.vue";
import TableList from "../../components/Table/table.vue";
import storeAdmissionCue from "@/views/Admissioncue/admissionCue.js";
export default {
  name: "listSearch-listSearch",
  data() {
    return {
      openMenu: ["5"],
      showSliderBox: false,
      fullscreenLoading: true, //全屏loading
      settingVisible: false,
      cancelRegister: false, //取消转正弹框
      client_id: "", //单个客户id
      oprateColumn: [1, 4], //编辑列
      showColumn: [],
      data: [],
      currentPage: 1,
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      dialogVisible: false,
      //筛选条件
      selectForm: {
        keyword: "",
      },
      SchoolCourseOption: [],
      chiefPerson: [],

      visitedJG: false,
      visitingJG: false,
      levelNum: 5, //侧边栏个数
      sliderWidth: "600px", //侧边栏宽度
      activeName: "first",

      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: false, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: Number, //表格高度
        errortip: "",
        // specialColumns:true//特殊列
      },
      columns: [],
      allColumns: [],
      operates: {
        width: 150,
        label: this.$t("Admissioncue.ca"),
        align: "center",
        fixed: "right",
        list: [
          // {
          //   id: "1",
          //   label: "取消转正",
          //   type: "text",
          //   show: true,
          //   plain: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.cancelRegister = true;
          //     this.client_id = row.client_id;
          //   }
          // }
        ],
      }, // 列操作按钮
      tableOperate: {
        label: "11",
        operate: true,
        align: "center",
        fixed: "right",
      },
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  components: {
    PageNav,
    TableList,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    if (this.postbe_crmlevel == "0") {
      this.operates.list = [];
    }
    this.SereachOneData();
    // this.getMarketer(); // 获取招生的负责人
    // this.getArealyCourseApiData(); // 获取学校的课程
    this.optionscaozuo.tableHeight = this.$Common.getTableHeight(250); //设置表格高度
  },
  mounted() {},
  methods: {
    // 检索名单表格数据
    SereachOneData() {
      storeAdmissionCue
        .SereachOne({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          is_count: "1", //是否需要总数，可以不传
          // p: this.currentPage,
          // num: this.pagesize,
          // 非必须传
          keyword: this.selectForm.keyword,
        })
        .then((res) => {
          this.tableData = res.data.data.list;
          this.dataNumber = parseInt(res.data.data.allnum);
          var Columns = res.data.data.field;
          this.columns = this.$Common.handleTable(
            Columns,
            this.columnWidth,
            true,
            -1
          );
          this.optionscaozuo.loading = false;
          if (res.data.code !== 200) {
            this.optionscaozuo.errortip = res.data.msg;
          }
        });
    },
    // 获取学校的课程
    getArealyCourseApiData() {
      // SchoolClassOption
      storeAdmissionCue
        .getArealyCourseApi({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data);
          this.SchoolCourseOption = res.data.data.list;
          //重置筛选
          // this.SchoolCourseOption.unshift(
          //   {
          //     course_branch: "", course_cnname: "不限"
          //   }
          // );
        });
    },
    // 获取招生的负责人
    getMarketer() {
      storeAdmissionCue
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.chiefPerson = res.data.data.list;
          this.chiefPerson.unshift({
            marketer_id: "",
            marketer_name: this.$t("Admissioncue.af"),
          });
        });
    },
    // Crm->删除转正记录-取消转正
    delDonversionAction() {
      storeAdmissionCue
        .delDonversionAction({
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          company_id: this.company_id,
          client_id: this.client_id,
          postbe_crmlevel: this.postbe_crmlevel,
        })
        .then((res) => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.SereachOneData();
            this.cancelRegister = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.SereachOneData();
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      this.SereachOneData();
    },
    // 编辑列
    Changeoprate() {
      (() => {})("列变化");
    },
    // 自定义编辑列
    handClickOprate() {
      let allnum = JSON.parse(localStorage.getItem("allregisterColumns"));
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item, index) => {
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      this.$Tool.setStorage("showregisterColumns", this.showColumns);
      this.settingVisible = false;
      this.SereachOneData();
      (() => {})(allnum);
    },
    // 显示 列切换
    toggleEditableColumn() {
      (() => {})("显示 列切换");
      this.settingVisible = !this.settingVisible;
    },
    hideSliderBox() {
      this.showSliderBox = false;
    },
    handleDel() {
      this.dialogVisible = true;
    },
    onSubmit() {
      (() => {})(this.form);
    },
    changeSize() {
      (() => {})("change");
    },
    handleSliderClick(tab, event) {
      (() => {})(tab, event);
    },
    handleOneClick(v1) {
      this.visitedJG = true;
      (() => {})(v1);
    },
    handleTwoClick(v1) {
      this.visitingJG = true;
      (() => {})(v1);
    },
    handleClick(v) {
      this.showSliderBox = true;
      (() => {})(v);
      //  this.canvasWidth();
      //  this.comparedDrawLine();
      // this.$message({
      //   message: `123232421432535`,
      //   type: 'success'
      // })
    },
    handleClose(done) {
      this.$confirm(this.$t("Admissioncue.cl"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagesize = val;
      this.SereachOneData();
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      this.SereachOneData(val);
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error(this.$t("Admissioncue.ea"));
      }
      if (!isLt2M) {
        this.$message.error(this.$t("Admissioncue.eb"));
      }
      return isJPG && isLt2M;
    },
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("admissionCue.less");
.listSearch {
  height: 100vh;
  font-size: 20px;
}
</style>
